import moduleName from './main.module';
import './card-security-code/card_security_code.directive.js';
import './credit-card-number/credit_card_number.directive.js';
import './currency-filed/currency_field.directive.js';
import './entry.module.js';
import './focus/focus.directive.js';
import './form/form.directive.js';
import './input-group-manager/input_group_manager.directive.js';
import './input-group/input_group.directive.js';
import './main.module.js';
import './match-input/match_input.directive.js';
import './ng-max/ng_max.directive.js';
import './ng-min/ng_min.directive.js';
import './question-label/question_label.directive.js';
import './question-line/question_line.directive.js';
import './question-link/question_link.directive.js';
import './question-set/question_set.directive.js';
import './question-setup/question_setup.directive.js';
import './question/question.controller.js';
import './question/question.directive.js';
export default moduleName;


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/-inputs/entry.module.js